import Config from 'hooks/config';

export const SANDBOX_CALLBACK_COOKIE = 'control_panel_sandbox_base_path';

const COOKIE_MAX_AGE_SECONDS = 30 * 60;

const getSandboxBasePath = () => {
    if (!Config.auth0RedirectUri) {
        return;
    }

    const basePath = Config.basename.replace(/^\/+|\/+$/g, '');

    if (!basePath || basePath === 'control-panel') {
        return;
    }

    return basePath;
};

export const isSandboxAuth0CallbackPath = () => {
    if (!Config.auth0RedirectUri || typeof window === 'undefined') {
        return false;
    }

    let callbackPath;

    try {
        callbackPath = new URL(Config.auth0RedirectUri, window.location.origin)
            .pathname;
    } catch {
        return false;
    }

    const basePath = Config.basename.replace(/\/+$/g, '');

    return (
        window.location.pathname === `${basePath}${callbackPath}` ||
        window.location.pathname === callbackPath
    );
};

export const rememberSandboxCallbackBasePath = () => {
    const sandboxBasePath = getSandboxBasePath();

    if (
        !sandboxBasePath ||
        typeof window === 'undefined' ||
        typeof document === 'undefined'
    ) {
        return;
    }

    const secure = window.location.protocol === 'https:' ? '; Secure' : '';

    document.cookie = `${SANDBOX_CALLBACK_COOKIE}=${encodeURIComponent(
        sandboxBasePath
    )}; Path=/; Max-Age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${secure}`;
};

export const clearSandboxCallbackBasePath = () => {
    if (typeof document === 'undefined') {
        return;
    }

    document.cookie = `${SANDBOX_CALLBACK_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`;
};
